"use strict";

var _interopRequireDefault = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.reduce.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _vueCountTo = _interopRequireDefault(require("vue-count-to"));
var _dealers = require("@/api/dealers");
var _agents = require("@/api/agents");
var _products = require("@/api/products");
var _order = require("@/api/order");
var _ordersTickets = require("@/api/orders-tickets");
var _index = require("@/utils/index");
var _admin = require("@/store/modules/admin");
var _ordersDispatches = require("@/api/orders-dispatches");
var _index2 = _interopRequireDefault(require("@/components/Inr/index.vue"));
var _common = require("@/common");
var _dashboard = require("@/api/dashboard");
var _branchAgentService = require("@/services/branch-agent-service");
var _ledgers = require("@/api/ledgers");
var _ordersProductsDispatches = require("@/api/orders-products-dispatches");
var _reports = require("@/api/reports");
var _moment = _interopRequireDefault(require("moment"));
let default_1 = class extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.supportTicketCount = [];
    this.isReadOnly = false;
    this.orderStatus = [{
      status: 'Order Confirmed',
      tooltipText: 'Shows the Total Number of Orders Confirmed',
      color: 'blue',
      count: 0
    }, {
      status: 'Partial Dispatch',
      tooltipText: 'Shows the Total Number of Orders which are Partially Dispatched',
      color: 'info',
      count: 0
    }, {
      status: 'Order Dispatched',
      tooltipText: 'Shows the Total Number of Orders which are Completely Dispatched',
      color: 'info',
      count: 0
    }, {
      status: 'Order Cancelled',
      tooltipText: 'Shows the Total Number of Orders Cancelled',
      color: '',
      count: 0
    }, {
      status: 'Order Partial Cancelled',
      tooltipText: 'Shows the Total Number of Orders which are Partially Cancelled',
      color: '',
      count: 0
    }];
    this.dispatchStatus = [{
      status: 'Pending',
      tooltipText: 'Shows the Total Number of Pending Dispatches',
      color: 'warning',
      count: 0
    }, {
      status: 'Request Approval',
      tooltipText: 'Shows the Total Number of Dispatches Which are yet to be Approved or Rejected',
      color: 'warning',
      count: 0
    }, {
      status: 'Approved',
      tooltipText: 'Shows the Total Number of Approved Dispatches',
      color: 'success',
      count: 0
    }, {
      status: 'Rejected',
      tooltipText: 'Shows the Total Number of Rejected Dispatches',
      color: 'danger',
      count: 0
    }];
    this.items = [{
      value: 'Sales Report'
    }, {
      value: 'Item Wise Report'
    }, {
      value: 'Item Wise Report New'
    }, {
      value: 'Outstanding Ageing Report'
    }, {
      value: 'Payments Report'
    }, {
      value: 'Range Wise Report'
    },
    // { value: 'Average Report' },
    {
      value: 'Ledgers'
    }, {
      value: 'Admins'
    }, {
      value: 'Dealers'
    }, {
      value: 'Products'
    }, {
      value: 'Ranges'
    }, {
      value: 'Branches'
    }, {
      value: 'Agents'
    }, {
      value: 'Orders'
    }, {
      value: 'Dispatches'
    }];
    this.dealerCount = 0;
    this.agentCount = 0;
    this.productscount = 0;
    this.orderscount = 0;
    this.totalOutstandingAmount = 0;
    this.totalStockValue = 0;
    this.totalPendingLedgers = 0;
    this.ledgerPaymentTypeSummary = [];
    this.totalAmountReceived = 0;
    this.totalFySales = 0;
    this.averageSales = 0;
    this.totalFyPayment = 0;
    this.totalPrevFySales = 0;
    this.totalPrevFyPayment = 0;
    this.currentRecievableAmount = 0;
    this.totalPendingOrders = 0;
    this.currentMonthSales = 0;
    this.currentMonthPayments = 0;
    this.previousMonthSales = 0;
    this.previousFinancialYearDate = '';
    this.previousMonthPayments = 0;
    this.dailyOrderValue = 0;
    this.topProducts = [];
    this.topDealers = [];
    this.dateRange = '';
    this.superAdmin = false;
    this.isAgent = false;
    this.agentId = undefined;
    this.currentDateRange = '';
    this.overdueAmount30days = 0;
    this.overdueAmount60days = 0;
    this.overdueAmount90days = 0;
    this.overdueAmount120days = 0;
    this.currentMonthOrderValue = 0;
    this.currentMonthOrderCount = 0;
    this.currentMonthDate = '';
    this.currentFinancialYearDate = '';
    this.previousMonthDate = '';
    this.branchListLoading = false;
    this.branchList = [];
    this.branchId = null;
    this.assignedBranches = [] || null;
    this.explicitAdminStockValueBranches = null;
    this.applyBranchIdFilter = true;
    this.excludeBranches = false;
    this.totalAdvanceAmount = 0;
    this.curvySeriesTotal = 0;
    this.deluxeSeriesTotal = 0;
    this.epicSeriesTotal = 0;
    this.iconnectSeriesTotal = 0;
    this.lyfeSeriesTotal = 0;
    this.mcbSeriesTotal = 0;
    this.oliveSeriesTotal = 0;
    this.ouraSeriesTotal = 0;
    this.vivaSeriesTotal = 0;
    this.query = '';
  }
  // private isAllowed() {
  //   return !isRegionalManager() && !isBranchManager();
  // }
  async activated() {
    try {
      var _AdminModule$branchId;
      if ((0, _common.isReadOnly)()) {
        this.isReadOnly = true;
      }
      if (_admin.AdminModule.roles.includes('Super Admin')) {
        this.superAdmin = true;
      }
      if (_admin.AdminModule.userType === 'Agent') {
        this.isAgent = true;
        this.agentId = _admin.AdminModule.agentId;
      }
      if (_admin.AdminModule.branchIds.length === 0) {
        throw new Error('You are not assigned to a branch.');
      }
      // Assign branchId using BranchAgentService
      this.assignedBranches = await _branchAgentService.BranchAgentService.assignBranchId();
      // Check if branchId is null and throw an error
      if (this.assignedBranches === null) {
        throw new Error('You are not assigned to a branch.');
      }
      // Total Stock Value tile: for a Zonal Manager or Branch Manager, scope
      // strictly to admins_branches (may be an empty array), not the
      // broader branchIds.
      this.explicitAdminStockValueBranches = await _branchAgentService.BranchAgentService.resolveExplicitAdminBranches();
      // Fetch branches for non-super admin users
      this.branchList = await _branchAgentService.BranchAgentService.fetchBranches(this.assignedBranches);
      this.excludeBranches = true;
      this.currentMonthDate = {
        start: this.$moment().startOf('month').format('YYYY-MM-DD 00:00') + ' am',
        end: this.$moment().endOf('month').format('YYYY-MM-DD 11:59') + ' pm'
      };
      this.currentFinancialYearDate = {
        start: this.$moment().month(this.$moment().month() < 3 ? 3 : 3).date(1).subtract(this.$moment().month() < 3 ? 1 : 0, 'year').startOf('day').format('YYYY-MM-DD 00:00') + ' am',
        end: this.$moment().month(2).date(31).add(this.$moment().month() < 3 ? 0 : 1, 'year').endOf('day').format('YYYY-MM-DD 11:59') + ' pm'
      };
      this.previousFinancialYearDate = {
        start: this.$moment().month(3).date(1).subtract(this.$moment().month() < 3 ? 2 : 1, 'year').startOf('day').format('YYYY-MM-DD 00:00') + ' am',
        end: this.$moment().month(2).date(31).add(this.$moment().month() < 3 ? -1 : 0, 'year').endOf('day').format('YYYY-MM-DD 11:59') + ' pm'
      };
      this.previousMonthDate = {
        start: this.$moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD 00:00') + ' am',
        end: this.$moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD 11:59') + ' pm'
      };
      this.currentDateRange = {
        start: this.$moment().startOf('day').format('YYYY-MM-DD hh:mm') + ' am',
        end: this.$moment().endOf('day').format('YYYY-MM-DD hh:mm') + ' pm'
      };
      if (!(0, _common.isSuperAdmin)() && !(0, _common.isAdmin)() && ((_AdminModule$branchId = _admin.AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
        this.branchId = _admin.AdminModule.branchIds[0];
      }
      this.getAllTilesData();
      // this.getSupportTicketCount();
    } catch (err) {
      if (err instanceof Error) {
        this.$notify.error({
          title: 'Error',
          message: err.message
        });
      }
    }
  }
  searchSuggestions(query, callback) {
    // Filter the items array to find matches
    const results = this.items.filter(item => item.value.toLowerCase().includes(query.toLowerCase()));
    const limitedResults = results.slice(0, 5);
    callback(limitedResults); // Return filtered results
  }
  handleSelect(item) {
    this.query = item.value; // Set the input value to the selected item
    if (item.value === 'Sales Report') {
      this.$router.push('/report/salesReport/list');
      this.query = '';
    }
    if (item.value === 'Sales Report') {
      this.$router.push('/report/salesReport/list');
      this.query = '';
    }
    if (item.value === 'Item Wise Report') {
      this.$router.push('/report/itemWiseReport/list');
      this.query = '';
    }
    if (item.value === 'Item Wise Report New') {
      this.$router.push('/report/newItemWiseReport/list');
      this.query = '';
    }
    if (item.value === 'Outstanding Ageing Report') {
      this.$router.push('/report/dealerWiseOsOdReport/list');
      this.query = '';
    }
    if (item.value === 'Range Wise Report') {
      this.$router.push('/report/range-wise-report/list');
      this.query = '';
    }
    if (item.value === 'Payments Report') {
      this.$router.push('/report/paymentReport/list');
      this.query = '';
    }
    // if (item.value === 'Average Report') {
    //   this.$router.push('/report/averageReport/list')
    //   this.query = ''
    // }
    if (item.value === 'Ledgers') {
      this.$router.push('/ledgers/list');
      this.query = '';
    }
    if (item.value === 'Admins') {
      this.$router.push('/admins/list');
      this.query = '';
    }
    if (item.value === 'Dealers') {
      this.$router.push('/dealers/list');
      this.query = '';
    }
    if (item.value === 'Products') {
      this.$router.push('/product/list');
      this.query = '';
    }
    if (item.value === 'Ranges') {
      this.$router.push('/ranges/list');
      this.query = '';
    }
    if (item.value === 'Branches') {
      this.$router.push('/branch/list');
      this.query = '';
    }
    if (item.value === 'Agents') {
      this.$router.push('/agents/list');
      this.query = '';
    }
    if (item.value === 'Orders') {
      this.$router.push('/order/list');
      this.query = '';
    }
    if (item.value === 'Dispatches') {
      this.$router.push('/orders-dispatches/list');
      this.query = '';
    }
  }
  async getAllTilesData() {
    if (_admin.AdminModule.userType === 'Admin') {
      this.fetchTotalOutstanding();
      this.getDealerCount();
      this.getProductCount();
      this.getAgentCount();
      this.getOrderStatusCount();
      this.getDispatchStatusCount();
      this.fetchTotalCollection();
      this.fetchTotalFySales();
      this.fetchAverageSales();
      this.fetchTotalFyPayment();
      this.fetchTotalPrevFySales();
      this.fetchTotalPrevFyPayment();
      this.fetchCurrentRecievable();
      this.fetchTotalPendingOrders();
      this.fetchCurrentMonthSales();
      this.fetchCurrentMonthPayments();
      this.fetchPreviousMonthPayments();
      this.fetchPreviousMonthSales();
      this.fetchDailyOrderValue();
      this.fetchSellingTopProducts();
      this.fetchTopDealers();
      this.fetchTotalAdvance();
      this.fetchCurrentMonthOrderValue();
      this.fetchPendingLedgers();
      this.fetchTotalAdvance();
      this.fetchTotalRangeWise();
      this.fetchTotalStockValue();
      this.fetchLedgerPaymentTypeSummary();
    }
  }
  async fetchTotalAdvance() {
    const params = {
      applyBranchIdFilter: true,
      fromDashboard: true,
      advance: true,
      excludeBranches: this.excludeBranches
    };
    if (this.dateRange) {
      params.startDate = this.dateRange.start;
      params.endDate = this.dateRange.end;
    }
    if (this.branchId) {
      params.branchId = this.branchId;
    }
    const data = await (0, _dashboard.totalOutstanding)(params);
    this.totalAdvanceAmount = data.totalBalance;
  }
  async fetchTotalRangeWise() {
    try {
      const currentMonth = (0, _moment.default)().month();
      const currentYear = (0, _moment.default)().year();
      // Determine financial year start and end
      const isFinancialYearStart = currentMonth >= 3; // April starts financial year
      const startYear = isFinancialYearStart ? currentYear : currentYear - 1;
      const endYear = startYear + 1;
      const params = {
        applyBranchIdFilter: true,
        fromDashboard: true,
        excludeBranches: this.excludeBranches,
        startDate: (0, _moment.default)(`${startYear}-04-01 00:00:00`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD hh:mm a'),
        endDate: (0, _moment.default)(`${endYear}-03-31 23:59:59`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD hh:mm a')
      };
      if (this.branchId) {
        params.branchId = this.branchId;
      }
      const data = await (0, _ordersProductsDispatches.getRangeWiseReports)(params);
      const allData = data.data;
      let curvySeries = 0;
      let deluxeSeries = 0;
      let epicSeries = 0;
      let iconnectSeries = 0;
      let lyfeSeries = 0;
      let mcbSeries = 0;
      let oliveSeries = 0;
      let ouraSeries = 0;
      let vivaSeries = 0;
      allData.forEach(item => {
        curvySeries += parseFloat(item.curvySeries);
        deluxeSeries += parseFloat(item.deluxeSeries);
        epicSeries += parseFloat(item.epicSeries);
        iconnectSeries += parseFloat(item.iconnectSeries);
        lyfeSeries += parseFloat(item.lyfeSeries);
        mcbSeries += parseFloat(item.mcbSeries);
        oliveSeries += parseFloat(item.oliveSeries);
        ouraSeries += parseFloat(item.ouraSeries);
        vivaSeries += parseFloat(item.vivaSeries);
      });
      this.curvySeriesTotal = curvySeries;
      this.deluxeSeriesTotal = deluxeSeries;
      this.epicSeriesTotal = epicSeries;
      this.iconnectSeriesTotal = iconnectSeries;
      this.lyfeSeriesTotal = lyfeSeries;
      this.mcbSeriesTotal = mcbSeries;
      this.oliveSeriesTotal = oliveSeries;
      this.ouraSeriesTotal = ouraSeries;
      this.vivaSeriesTotal = vivaSeries;
    } catch (error) {
      this.$message.error('Error Loading Range Wise Data');
    }
  }
  _isAdminRoles() {
    return (0, _common.isSuperAdmin)() || (0, _common.isAdmin)() || (0, _common.isReadOnly)();
  }
  _isInvoiceManager() {
    return (0, _common.isInvoiceManager)();
  }
  _isReadOnly() {
    return (0, _common.isReadOnly)();
  }
  _isUnitManager() {
    return (0, _common.isUnitManager)();
  }
  _isZonalManager() {
    return (0, _common.isZonalManager)();
  }
  _isBranchManager() {
    return (0, _common.isBranchManager)();
  }
  onCheckboxChange(value) {
    this.excludeBranches = value;
    this.getAllTilesData();
  }
  async handleFilter() {
    var _AdminModule$branchId2;
    // handle branch and agent code
    // Fetch agents for a single branch
    if ((!(0, _common.isSuperAdmin)() || !(0, _common.isAdmin)()) && ((_AdminModule$branchId2 = _admin.AdminModule.branchIds) === null || _AdminModule$branchId2 === void 0 ? void 0 : _AdminModule$branchId2.length) === 1) {
      this.branchId = _admin.AdminModule.branchIds[0];
    }
    // if (!this._isAdminRoles()) {
    this.excludeBranches = true;
    // }
    if (this.branchId !== undefined) {
      await _branchAgentService.BranchAgentService.fetchBranches(this.branchId);
      // Fetch the list after agents and branches are loaded
      this.getAllTilesData();
    } else {
      // await this.handleClearBranch();
      this.getAllTilesData();
    }
  }
  async getOrderStatusCount() {
    try {
      // Build the query object
      const query = {
        enabled: true,
        applyBranchIdFilter: true
      };
      // Add branchId to query if it's defined
      if (this.branchId) {
        query.branchId = this.branchId;
      }
      if (this.currentFinancialYearDate) {
        query.startDate = this.currentFinancialYearDate.start;
        query.endDate = this.currentFinancialYearDate.end;
      }
      // Pass the query to getStatusCount
      const data = await (0, _order.getStatusCount)(query);
      // Update the order status counts
      this.orderStatus.forEach(item => {
        item.count = data[item.status] * 1;
      });
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async getDispatchStatusCount() {
    try {
      // Build the query object
      const query = {
        enabled: true,
        applyBranchIdFilter: true
      };
      // Add branchId to query if it's defined
      if (this.branchId) {
        query.branchId = this.branchId;
      }
      if (this.currentFinancialYearDate) {
        query.startDate = this.currentFinancialYearDate.start;
        query.endDate = this.currentFinancialYearDate.end;
      }
      // Pass the query to getStatusCount
      const data = await (0, _ordersDispatches.getDispatchCount)(query);
      this.dispatchStatus.forEach(item => {
        item.count = data[item.status] * 1;
      });
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchTotalOutstanding() {
    const params = {
      applyBranchIdFilter: true,
      fromDashboard: true,
      excludeBranches: this.excludeBranches
    };
    if (this.dateRange) {
      params.startDate = this.dateRange.start;
      params.endDate = this.dateRange.end;
    }
    if (this.branchId) {
      params.branchId = this.branchId;
    }
    const data = await (0, _dashboard.totalOutstanding)(params);
    this.totalOutstandingAmount = data.totalBalance;
  }
  async fetchPendingLedgers() {
    const params = {
      applyBranchIdFilter: true,
      isSuperAdmin: false
    };
    if (this.branchId) {
      params.branchId = this.branchId;
    }
    if ((0, _common.isSuperAdmin)()) {
      params.isSuperAdmin = true;
    }
    const data = await (0, _ledgers.getPendingPaymentLedgerCount)(params);
    this.totalPendingLedgers = data;
  }
  // Approved-only count + amount per note/voucher paymentType, for the
  // ledger summary table.
  async fetchLedgerPaymentTypeSummary() {
    try {
      const query = {
        excludeBranches: this.excludeBranches
      };
      if (this.branchId) {
        query.branchId = this.branchId;
      } else if (this.assignedBranches) {
        query.branchId = this.assignedBranches;
      }
      const data = await (0, _ledgers.getLedgerPaymentTypeCounts)(query);
      this.ledgerPaymentTypeSummary = data.data || [];
    } catch (error) {
      this.ledgerPaymentTypeSummary = [];
    }
  }
  getLedgerSummaryTotals(param) {
    const {
      columns,
      data
    } = param;
    const sums = [];
    columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = 'Total';
        return;
      }
      if (column.property === 'count') {
        sums[index] = data.reduce((total, row) => total + (Number(row.count) || 0), 0);
        return;
      }
      if (column.property === 'amount') {
        sums[index] = data.reduce((total, row) => total + (Number(row.amount) || 0), 0);
        return;
      }
      sums[index] = '';
    });
    return sums;
  }
  async fetchTotalCollection() {
    const params = {
      limit: 5,
      applyBranchIdFilter: true
    };
    if (this.dateRange) {
      params.startDate = this.dateRange.start;
      params.endDate = this.dateRange.end;
    }
    if (this.branchId) {
      params.branchId = this.branchId;
    }
    const data = await (0, _dashboard.totalCollection)(params);
    this.totalAmountReceived = isNaN(+data.amountReceived) ? 0 : +data.amountReceived;
  }
  //  all sales related data from ledger table
  async fetchTotalFySales() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true,
      excludeBranches: this.excludeBranches
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    if (this.currentFinancialYearDate) {
      query.startDate = this.currentFinancialYearDate.start;
      query.endDate = this.currentFinancialYearDate.end;
    }
    const data = await (0, _dashboard.totalFySales)(query);
    this.totalFySales = isNaN(+data.totalAmount) ? 0 : +data.totalAmount;
  }
  // Average monthly sales for the current financial year (total FY-to-date
  // sales / months elapsed) - the date range is fixed server-side, so only
  // branch/exclude-branches scoping needs to be sent.
  async fetchAverageSales() {
    const query = {
      excludeBranches: this.excludeBranches
    };
    if (this.branchId) {
      query.branchId = this.branchId;
    } else if (this.assignedBranches) {
      query.branchId = this.assignedBranches;
    }
    const data = await (0, _dashboard.getAverageSales)(query);
    this.averageSales = isNaN(+data.averageSales) ? 0 : +data.averageSales;
  }
  async fetchCurrentMonthSales() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true,
      fromDashboard: true,
      excludeBranches: this.excludeBranches
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    if (this.currentMonthDate) {
      query.startDate = this.currentMonthDate.start;
      query.endDate = this.currentMonthDate.end;
    }
    const data = await (0, _dashboard.totalFySales)(query);
    this.currentMonthSales = isNaN(+data.totalAmount) ? 0 : +data.totalAmount;
  }
  async fetchPreviousMonthSales() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true,
      fromDashboard: true,
      excludeBranches: this.excludeBranches
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    if (this.previousMonthDate) {
      query.startDate = this.previousMonthDate.start;
      query.endDate = this.previousMonthDate.end;
    }
    const data = await (0, _dashboard.totalFySales)(query);
    this.previousMonthSales = isNaN(+data.totalAmount) ? 0 : +data.totalAmount;
  }
  //  all sales related data from ledger table
  // all payment related data from transaction table
  async fetchTotalFyPayment() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true,
      excludeBranches: this.excludeBranches
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    if (this.currentFinancialYearDate) {
      query.startDate = this.currentFinancialYearDate.start;
      query.endDate = this.currentFinancialYearDate.end;
    }
    const data = await (0, _dashboard.totalFyPayment)(query);
    this.totalFyPayment = isNaN(+data) ? 0 : +data;
  }
  async fetchTotalPrevFySales() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true,
      excludeBranches: this.excludeBranches
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    if (this.previousFinancialYearDate) {
      query.startDate = this.previousFinancialYearDate.start;
      query.endDate = this.previousFinancialYearDate.end;
    }
    const data = await (0, _dashboard.totalFySales)(query);
    this.totalPrevFySales = isNaN(+data.totalAmount) ? 0 : +data.totalAmount;
  }
  async fetchTotalPrevFyPayment() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true,
      excludeBranches: this.excludeBranches
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    if (this.previousFinancialYearDate) {
      query.startDate = this.previousFinancialYearDate.start;
      query.endDate = this.previousFinancialYearDate.end;
    }
    const data = await (0, _dashboard.totalFyPayment)(query);
    this.totalPrevFyPayment = isNaN(+data) ? 0 : +data;
  }
  async fetchCurrentMonthPayments() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true,
      excludeBranches: this.excludeBranches
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    if (this.currentMonthDate) {
      query.startDate = this.currentMonthDate.start;
      query.endDate = this.currentMonthDate.end;
    }
    const data = await (0, _dashboard.totalFyPayment)(query);
    this.currentMonthPayments = isNaN(+data) ? 0 : +data;
  }
  async fetchPreviousMonthPayments() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true,
      excludeBranches: this.excludeBranches
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    if (this.previousMonthDate) {
      query.startDate = this.previousMonthDate.start;
      query.endDate = this.previousMonthDate.end;
    }
    const data = await (0, _dashboard.totalFyPayment)(query);
    this.previousMonthPayments = isNaN(+data) ? 0 : +data;
  }
  // all payment related data from transaction table
  async fetchCurrentRecievable() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    const data = await (0, _dashboard.totalCurrentRecievable)(query);
    this.currentRecievableAmount = isNaN(+data.totalOutstanding) ? 0 : +data.totalOutstanding;
  }
  async fetchTotalPendingOrders() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    const data = await (0, _dashboard.totalPendingOrders)(query);
    this.totalPendingOrders = isNaN(+data) ? 0 : +data;
  }
  async fetchDailyOrderValue() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    const currentDate = this.$moment().format('YYYY-MM-DD');
    const startOfDay = this.$moment(currentDate).startOf('day').format('YYYY-MM-DD HH:mm:ss');
    const endOfDay = this.$moment(currentDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');
    query.startDate = startOfDay;
    query.endDate = endOfDay;
    const data = await (0, _dashboard.getDailyOrderValue)(query);
    this.dailyOrderValue = isNaN(+data.total) ? 0 : +data.total;
  }
  async fetchCurrentMonthOrderValue() {
    const query = {
      agentId: undefined,
      applyBranchIdFilter: true
    };
    if (this.agentId) {
      query.agentId = this.agentId;
    }
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    if (this.currentMonthDate) {
      query.startDate = this.currentMonthDate.start;
      query.endDate = this.currentMonthDate.end;
    }
    const data = await (0, _dashboard.getCurrentMonthOrderValue)(query);
    if (data) {
      this.currentMonthOrderValue = isNaN(+data.total) ? 0 : +data.total;
      this.currentMonthOrderCount = isNaN(+data.count) ? 0 : +data.count;
    }
  }
  async fetchTotalStockValue() {
    try {
      // Zonal Manager / Branch Manager: strictly scope to admins_branches,
      // ignoring the broader branchId/assignedBranches used everywhere
      // else. An empty admins_branches mapping means zero, not "no filter".
      if (this.explicitAdminStockValueBranches !== null) {
        if (this.explicitAdminStockValueBranches.length === 0) {
          this.totalStockValue = 0;
          return;
        }
        const data = await (0, _reports.getTotalStockValue)({
          enabled: true,
          page: 1,
          limit: 1000,
          assignedBranches: this.explicitAdminStockValueBranches.join(',')
        });
        this.totalStockValue = data.totalStockValue;
        return;
      }
      const query = {
        enabled: true,
        page: 1,
        limit: 1000
      };
      if (this.branchId) {
        query.branchId = this.branchId;
      } else if (this.assignedBranches) {
        query.assignedBranches = Array.isArray(this.assignedBranches) ? this.assignedBranches.join(',') : this.assignedBranches;
      }
      const data = await (0, _reports.getTotalStockValue)(query);
      this.totalStockValue = data.totalStockValue;
    } catch (error) {
      this.totalStockValue = 0;
    }
  }
  async fetchOverdueByDays() {
    let params = {
      days: 30,
      dealerWise: false
    };
    const data30 = await (0, _dashboard.getOverdueByDays)(params);
    this.overdueAmount30days = +data30.overdueDealers[0].overdueAmount.toFixed(2);
    params = {
      days: 60,
      dealerWise: false
    };
    const data60 = await (0, _dashboard.getOverdueByDays)(params);
    this.overdueAmount60days = +data60.overdueDealers[0].overdueAmount.toFixed(2);
    params = {
      days: 90,
      dealerWise: false
    };
    const data90 = await (0, _dashboard.getOverdueByDays)(params);
    this.overdueAmount90days = +data90.overdueDealers[0].overdueAmount.toFixed(2);
    params = {
      days: 120,
      dealerWise: false
    };
    const data120 = await (0, _dashboard.getOverdueByDays)(params);
    this.overdueAmount120days = +data120.overdueDealers[0].overdueAmount.toFixed(2);
  }
  async fetchSellingTopProducts() {
    const params = {
      limit: 10,
      applyBranchIdFilter: true,
      excludeBranches: this.excludeBranches
    };
    if (this.dateRange) {
      params.startDate = this.dateRange.start;
      params.endDate = this.dateRange.end;
    }
    if (params.branchId) {
      params.branchId = this.branchId;
    }
    const data = await (0, _dashboard.topSellingProducts)(params);
    this.topProducts = data.data;
  }
  // need to verify
  async fetchTopDealers() {
    const params = {
      limit: 10,
      applyBranchIdFilter: true,
      excludeBranches: this.excludeBranches
    };
    if (this.dateRange) {
      params.startDate = this.dateRange.start;
      params.endDate = this.dateRange.end;
    }
    if (this.branchId) {
      params.branchId = this.branchId;
    }
    const data = await (0, _dashboard.topDealers)(params);
    this.topDealers = data.data;
  }
  async getSupportTicketCount() {
    this.supportTicketCount = await (0, _ordersTickets.ordersTicketsCount)({});
  }
  async getDealerCount() {
    try {
      // Build the query conditionally based on branchId
      const query = {
        enabled: true,
        branchId: undefined,
        applyBranchIdFilter: true,
        fromDealer: true
      };
      if (this.branchId) {
        query.branchId = this.branchId;
      }
      this.dealerCount = await (0, _dealers.dealersCount)((0, _index.getQuery)(query));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async getProductCount() {
    try {
      this.productscount = await (0, _products.productCount)((0, _index.getQuery)({
        enabled: true,
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async getAgentCount() {
    // Build the query conditionally based on branchId
    const query = {
      enabled: true,
      branchId: undefined,
      applyBranchIdFilter: true
    };
    // Add branchId to query if it's defined
    if (this.branchId) {
      query.branchId = this.branchId;
    }
    this.agentCount = await (0, _agents.getAgentBranchWiseCount)((0, _index.getQuery)(query));
  }
  getCurrentMonthDateRange() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    // Start date: first day of the current month at 12:00 AM
    const startDate = new Date(year, month, 1, 0, 0, 0);
    // End date: last day of the current month at 11:59 PM
    const endDate = new Date(year, month + 1, 0, 23, 59, 59);
    // Formatting the dates as "YYYY-MM-DD hh:mm AM/PM"
    const formatDate = date => {
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      };
      const dateStr = date.toLocaleString('en-US', options).replace(',', '');
      // Replace "/" with "-" in the date part
      return dateStr.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$1-$2');
    };
    return {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate)
    };
  }
  generateReportLink() {
    const currentDateRange = this.getCurrentMonthDateRange();
    const startDate = currentDateRange.startDate;
    const endDate = currentDateRange.endDate;
    return `/report/salesReport/list?startDate=${startDate}&endDate=${endDate}`;
  }
  async dateval() {
    await this.fetchTotalFySales();
  }
  isSuperAdmin() {
    return _admin.AdminModule.roles.indexOf('Super Admin') > -1;
  }
  _isAdmin() {
    return (0, _common.isAdmin)();
  }
  hasNoAccess(requiredRoles) {
    return (0, _common.isExcludedToAccess)(requiredRoles);
  }
};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'PanelGroup',
  components: {
    CountTo: _vueCountTo.default,
    Inr: _index2.default
  }
})], default_1);
var _default = exports.default = default_1;